import { useEffect, useState } from 'react';
import { getOrders } from '../services/adminWorkspaceService';
import { getTryOnBookings } from '../services/tryOnService';

const DISMISSED_KEY = 'zevi-admin-dismissed-notifications';

function AdminNotifications({ onNavigate, onCount }) {
  const [alerts, setAlerts] = useState([]);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    async function load() {
      try {
        const [orders, bookings] = await Promise.all([
          getOrders(), getTryOnBookings().catch(() => [])
        ]);
        if (!active) return;
        const rows = [
          ...orders.filter((o) => ['proof_submitted', 'under_review'].includes(o.payment_status))
            .map((o) => ({ id: `proof-${o.id}`, title: `Payment proof: ${o.order_number}`, tab: 'orders' })),
          ...orders.filter((o) => o.order_status === 'order_received')
            .map((o) => ({ id: `new-${o.id}`, title: `New order: ${o.order_number}`, tab: 'orders' })),
          ...bookings.filter((b) => b.status === 'requested')
            .map((b) => ({ id: `booking-${b.id}`, title: `Try-on request: ${b.customer_name}`, tab: 'try-on' }))
        ];
        const dismissed = new Set(JSON.parse(localStorage.getItem(DISMISSED_KEY) || '[]'));
        const visible = rows.filter((row) => !dismissed.has(row.id));
        setAlerts(visible);
        onCount(visible.length);
        setError('');
      } catch {
        if (active) setError('Notifications could not be loaded.');
      }
    }
    load();
    const timer = setInterval(load, 30000);
    return () => { active = false; clearInterval(timer); };
  }, [onCount]);

  const clear = () => {
    const dismissed = new Set(JSON.parse(localStorage.getItem(DISMISSED_KEY) || '[]'));
    alerts.forEach((alert) => dismissed.add(alert.id));
    localStorage.setItem(DISMISSED_KEY, JSON.stringify([...dismissed]));
    setAlerts([]);
    onCount(0);
  };

  return (
    <div className="zevi-notifications" role="region" aria-label="Admin notifications">
      <h3>Needs attention</h3>
      {alerts.length > 0 && (
        <button type="button" onClick={clear}>Clear notifications</button>
      )}
      {error && <p>{error}</p>}
      {!error && !alerts.length && <p>You’re all caught up.</p>}
      {alerts.map((alert) => (
        <button key={alert.id} type="button" onClick={() => onNavigate(alert.tab)}>
          {alert.title}
        </button>
      ))}
    </div>
  );
}

export default AdminNotifications;